module.exports = __webpack_public_path__ + "img/bn.791247e3.jpg";